module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": _vm.navPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'RFQs'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-no-bordered dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "disabled-sorting"
  }), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("TO #")]), _vm._v(" "), _c('th', [_vm._v("Shipper")]), _vm._v(" "), _c('th', [_vm._v("Consignee")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right",
    staticStyle: {
      "min-width": "70px"
    }
  }, [_vm._v("Actions")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601ff238"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rfq/view.vue
// module id = 721
// module chunks = 0